var util = require('./util')
var SiteTracker = function(s, p, r, u) {
    if (s != undefined && s != null) {
        this.site = s;
    }

    if (p != undefined && p != null) {
        this.page = p;
    }

    if (r != undefined && r != null) {
        this.referer = r;
    }

    if (u != undefined && u != null) {
        this.uid = u;
    }
};

SiteTracker.prototype.getCookie = function(sKey) {
    if (!sKey || !this.hasItem(sKey)) {
        return null;
    }
    return decodeURIComponent(document.cookie.replace(new RegExp("(?:^|.*;\\s*)" + encodeURIComponent(sKey).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=\\s*((?:[^;](?!;))*[^;]?).*"), "$1"));
};

SiteTracker.prototype.hasItem = function(sKey) {
    return (new RegExp("(?:^|;\\s*)" + encodeURIComponent(sKey).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=")).test(document.cookie);
};

SiteTracker.prototype.track = function(t_params) {
    this.buildParams();

    var src = "",
        script,
        params = [],
        content;

    if (typeof(t_params) == "undefined" || typeof(t_params.target_url) == "undefined") {
        src = location.protocol + "//s.anjuke.com/st?__site=" + encodeURIComponent(this.params['site']) + "&";
    } else {
        src = t_params.target_url + '?';
    }

    for (var k in this.params) {
        params.push(k + "=" + encodeURIComponent(this.params[k]));
    }
    src += params.join('&');
    script = document.createElement("script");
    script.src = src;
    script.async = true;
    content = (document.getElementsByTagName('head')[0] || document.getElementsByTagName('body')[0]);
    script.onload = function() {
        content.removeChild(script);
    }
    content.appendChild(script);
};

SiteTracker.prototype.buildParams = function() {
    var href = document.location.href;

    var gi = this.getCookie(this.nGuid || "aQQ_ajkguid" || "aQQ_gi");
    var ctid = this.nCtid || this.getCookie(this.nCtid || "ctid");
    var luid = this.getCookie(this.nLiu || "lui");
    var ssid = this.getCookie(this.nSessid || "sessid");
    var uid = this.getCookie(this.nUid || "ajk_member_id" || "node_member_id");

    if (this.uid != undefined && this.uid != null) {
        uid = this.uid;
    }

    if (uid == undefined || uid == null | uid == "") {
        uid = 0;
    }

    var method = "";
    if (this.method != undefined && this.method != null) {
        method = this.method;
    }

    this.params = new Object();
    this.params.p = this.page;
    this.params.h = href;
    this.params.r = this.referer;
    this.params.site = this.site;
    this.params.gi = gi;
    this.params.ssid = ssid;
    this.params.uid = uid;
    this.params.t = new Date().getTime();
    this.params.ctid = ctid;
    this.params.luid = luid;
    this.params.m = method;

    if (this.screen != undefined) {
        this.params.sc = JSON.stringify(this.screen);
    }

    if (this.cst != undefined && /[0-9]{13}/.test(this.cst)) {
        this.params.lt = this.params.t - parseInt(this.cst);
    }

    if (this.pageName != undefined) {
        this.params.pn = this.pageName;
    }

    if (this.customParam != undefined) {
        this.params.cp = this.customParam;
    }

    if (this.exposureParams != undefined) {
        this.params.ep = this.exposureParams;
      }

    if (this.plat != undefined) {
        this.params.plat = this.plat;
    }
    if (this.type != undefined) {
        this.params.type = this.type;
    }
    if (this.action != undefined) {
        this.params.action = this.action;
    }

};

SiteTracker.prototype.setSite = function(s) {
    this.site = s;
};

SiteTracker.prototype.setPage = function(p) {
    this.page = p;
};

SiteTracker.prototype.setPageName = function(n) {
    this.pageName = n;
};

SiteTracker.prototype.setCookieNames = function(c) {
    this.cookNames = c;
};

SiteTracker.prototype.setReferer = function(r) {
    this.referer = r;
};

SiteTracker.prototype.setUid = function(u) {
    this.uid = u;
};

SiteTracker.prototype.setMethod = function(m) {
    this.method = m;
};

SiteTracker.prototype.setNGuid = function(n) {
    this.nGuid = n;
};

SiteTracker.prototype.setNCtid = function(n) {
    this.nCtid = n;
};

SiteTracker.prototype.setNLiu = function(n) {
    this.nLiu = n;
};

SiteTracker.prototype.setNSessid = function(n) {
    this.nSessid = n;
};

SiteTracker.prototype.setNUid = function(n) {
    this.nUid = n;
};

SiteTracker.prototype.setCst = function(n) {
    this.cst = n;
};

SiteTracker.prototype.setScreen = function(v) {
    this.screen = v;
}
SiteTracker.prototype.setPlat = function(v) {
    this.plat = v;
}
SiteTracker.prototype.setType = function(v) {
    this.type = v;
}
SiteTracker.prototype.setAction = function(v) {
    this.action = v;
}

SiteTracker.prototype.setCustomParam = function(v) {
    var soj_source_h5 = {
        'source_h5': {
            app: '',
            os: '',
            ver: ''
        }
    };
    var source_h5 = document.getElementsByTagName('body')[0].dataset.sourceh5;
    try {
        if (source_h5 && source_h5.length > 0) {
            soj_source_h5 = JSON.parse(source_h5);
        }
    } catch (e) {

    }
    try {
        if (!v) {
            if (soj_source_h5) {
                var v = JSON.stringify(soj_source_h5);
            }
        } else {
            if (!util.isPlainObject(v)) {
                var jsondata = JSON.parse(v);
            } else {
                var jsondata = v;
            }
            if (!jsondata.hasOwnProperty('source_h5')) {
                if (soj_source_h5) {
                    jsondata.source_h5 = soj_source_h5.source_h5;
                }
                v = JSON.stringify(jsondata)
            }
        }
    } catch (e) {
        if (!v) {
            if (soj_source_h5)
                var v = JSON.stringify(soj_source_h5);
        } else {
            if (util.isPlainObject(v)) {
                v = JSON.stringify(v);
            }
            var a = v.split('');
            if (soj_source_h5)
                a[0] = a[0] + JSON.stringify(soj_source_h5);
            v = a.join('');
        }
    }
    this.customParam = v;
}

SiteTracker.prototype.setExposureparams = function(v) {
  this.exposureParams = v;
}

SiteTracker.prototype.getParams = function() {
    return this.params;
}

module.exports = SiteTracker;